export interface MessageEventData<T> {
    type: string;
    action: CRM_ACTIONS;
    data: T;
    requestId?: string;
}

export enum CRM_ACTIONS {
    // actions CRM -> RCX
    DIAL = 'DIAL',
    SUGGEST_DIAL = 'crm_suggestDial',
    CANCEL_SUGGEST_DIAL = 'crm_cancelSuggestDial',
    SEND_METADATA = 'crm_metadata',
    DISPOSITION_RESULT = 'crm_DispResult',
    SIGN_OUT_AGENT = 'sign_out_agent',
    SHOW_ERROR_BANNER = 'crm_showErrorBanner',
    ANALYTICS_TRACK = 'crm_analyticsTrack',
    UPDATE_STATE = 'crm_update_state',

    // actions RCX --> CRM
    CALL_NEW_CALL = 'call_newCall',
    CALL_END_CALL = 'call_endCall',
    CALL_PENDING_DISP = 'call_pendingDisp',
    CALL_SUBMIT_DISPOSITION = 'call_submitDisposition',
    SIP_CALL_ANSWERED = 'sip_callAnswered',
    SIP_CALL_REJECTED = 'sip_callRejected',
    SESSION_REGISTERED = 'sip_registered',
    CHAT_PRESENTED = 'chat_presented',
    CHAT_NEW_MESSAGE = 'chat_new_message',
    CHAT_SET_STATUS = 'chat_setStatus',
    ACD_CALLBACK_READY = 'call_acdCallbackReady',

    CHAT_ACCEPTED = 'chat_accepted',
    CHAT_REJECTED = 'chat_rejected',
    CHAT_DISP_RESPONSE = 'chat_dispResponse',
    CRM_OPEN_RECORD = 'crm_openRecord',
    CRM_POP_RECORDS = 'crm_popRecords',
    VIEW_CALL_LOG = 'crm_viewCallLog', // view call/digital log
    AGENT_LOGIN = 'agent_login',
    AGENT_LOGOUT = 'agent_logout',
    SET_RCX_METADATA = 'crm_rcx_metadata',
    GET_CRM_LOCALE = 'crm_get_locale',
    SEND_TO_CPR = 'crm_sendToCpr',
    STATE_CHANGED = 'agent_stateChanged',

    // pairs Inbound ACTION -> Outbound ACTION
    GET_MATCHING_RECORDS = 'crm_getMatchingRecords',
    SET_MATCHING_RECORDS = 'crm_setMatchingRecords',

    GET_MATCHING_TICKETS = 'crm_getMatchingTickets',
    SET_MATCHING_TICKETS = 'crm_setMatchingTickets',

    GET_SEARCH_RECORD = 'crm_getSearchRecords',
    SET_SEARCH_RECORD = 'crm_setSearchRecords',

    CRM_CREATE_RECORD = 'crm_createRecord',
    CRM_CREATE_RECORD_RESULT = 'crm_createRecordResult',

    GET_CALL_LINK = 'crm_getCallLink',
    SET_CALL_LINK = 'crm_setCallLink',
    SET_CHAT_LINK = 'crm_setChatLink',
    GET_CHAT_LINK = 'crm_getChatLink',

    SUBMIT_LOG = 'crm_submitLog',
    SUBMIT_LOG_RESULT = 'crm_submitLogResult',

    START_RENDER = 'crm_startRender',
    UPDATE_RENDER = 'crm_updateRender',
    STOP_RENDER = 'crm_stopRender',
    START_RENDER_RESULT = 'crm_startRenderResult',

    //script
    SET_SCRIPT_RESULT = 'crm_setScriptResult',

    GET_SCRIPT_DATA = 'crm_getScriptData',
    SET_SCRIPT_DATA = 'crm_setScriptData',
    SCRIPT_RERENDER = 'crm_scriptReRender',
    SCRIPT_CALLBACK = 'crm_scriptCallback',

    //error
    SCRIPT_UNHANDLED_REJECT = 'crm_scriptUnhandledReject',
    SCRIPT_ON_ERROR = 'crm_scriptOnError',
    SCRIPT_TOKEN_ERROR = 'crm_scriptTokenError',
    SIDECAR_ERROR = 'crm_sidecarError',

    // set locale
    SET_CRM_LOCALE = 'crm_set_locale',
    // lead selection
    LEAD_SELECTED = 'crm_selectLead',

    SCRIPT_ON_STORAGE_ERROR = 'crm_OnStorageError',
}

type Status = 'OK' | 'FAILURE';

type CallType = 'INBOUND' | 'OUTBOUND' | 'click_to_dial';
interface CallQueue {
    isCampaign: boolean;
    number?: string;
    name?: string;
    description?: string;
}
interface Lead {
    leadId: string;
    firstName?: string;
    lastName?: string;
    scriptId?: string;
}

export interface CallBase {
    callType?: CallType;
    errorCode?: string;
    callState?: string;
    callerName?: string;
    status?: Status;
    scriptId?: string;
    dnis?: string;
    dnisE164?: string;
    ani?: string;
    aniE164?: string;
    uii: string;
    lead?: Lead;
    leadId?: string;
    isManualAnswerCall?: boolean;
    baggage?: any;
    script?: any;
    timestamp?: number;
    queue?: CallQueue;
    firstName?: string;
    lastName?: string;
    queueDts?: string;
    isClickToDial?: boolean;
    queueTimestamp?: number;
    localCallLogInfo?: any;
    segmentContext?: SegmentContext;
    sessionData?: SessionData;
    isPredictiveOutbound?: boolean;
    type?: string;
}

interface SegmentContext {
    dialog?: any;
    customerIdentity?: any;
}

export interface SessionData {
    cx: Cx;
}

interface Cx {
    crm: Crm;
}

interface Crm {
    matchingRules: CrmMatchingRule[];
    logFields?: Record<string, string>;
    matchingResult?: CrmMatchingResult[];
}

export interface CrmMatchingRule {
    crmEntityType: string[];
    crmEntityIdName: string;
    crmEntityValue: string;
}

export interface CrmMatchingResult {
    crmEntityType: string;
    crmMatchedIds: string[];
    crmSearchValue?: string;
}

export interface ChatBase {
    message?: string;
    errorCode?: string;
    detail?: string;
    status?: Status;
    accountId?: string;
    taskId?: string;
    uii: string;
    edUuid?: string;
    channelType?: string;
    chatType?: string;
    chatQueueId?: string;
    chatQueueName?: string;
    edAuthorScreenName?: string;
    edLanguage?: string;
    lastMsgDts: string;
    segmentContext?: SegmentContext;
    sessionData?: SessionData;
    localChatLogInfo?: any;
    ani?: string;
}

export interface CallAcceptedData extends CallBase {
    agentId: string;
    type: 'CHAT-DISPOSITION';
}

export interface OnNewCall extends CallBase {
    outdialDispositions: OutdialDispositions;
}
export interface OnMatchRecord {
    type: 'Call' | 'Digital';
    params: CallBase | ChatBase;
}

export interface CommonNewFiled {
    Phone?: string; //e164 format
    RCX_Phone__c?: string;
}

export interface LeadCall extends CallBase {
    firstName?: string;
    lastName?: string;
}

export type PopEntryObject = {
    type: string; //sf: SfEntityType
    call: LeadCall | CallBase;
};

export interface OpenRecord {
    params: string;
    type: string;
    channelType?: string;
}

export interface PopRecords {
    params: string;
    uii?: string;
    type?: string;
    channelType?: string;
    matchType?: string;
}

export interface RecordCond {
    value: string;
    params?: Record<string, any>;
    type?: SearchType | RecordType;
    engageType?: ParamsType;
}
export enum SearchType {
    NAME = 'name',
    RELATED = 'related',
    ALL = 'all',
    REGARDING = 'regarding',
    BYRECORD = 'byRecord',
}
export interface Contact {
    id?: string;
    name: string;
    type?: RecordType;
    phoneNumber?: string;
    edUuid?: string;
}

export interface OnDispCall extends CallBase {
    notes: string;
    uii: string;
    dispId: string;
    disposition: string;
    duration?: string;
    recordingUrl?: string;
    summary?: string;
    localCallLogInfo?: any;
    transcriptUrl?: string;
}

interface OutdialDispositions {
    type: string;
    dispositions: Disposition[];
}
export interface Disposition {
    contactForwarding: boolean;
    dispositionId: string;
    isComplete: boolean;
    isDefault: boolean;
    requireNote: boolean;
    saveSurvey: boolean;
    timeout: string;
    xfer: boolean;
    disposition: string;
}

export interface OnEndCall {
    message: string;
    detail: string;
    status: string;
    errorCode: string;
    errorParams: Record<string, any>;
    uii: string;
    lead?: Lead;
    sessionId: string;
    agentId: string;
    callDts: string;
    duration: string;
    termParty: string;
    termReason: string;
    recordingUrl: string;
    transcriptUrl: string;
    dispositionTimeout: string;
    enableCallHistory: boolean;
    hasDisposition: boolean;
    hasSubmittedLog?: boolean;
    localCallLogInfo?: any;
}

export interface CrmMetadata {
    platform: PLATFORM;
    dockMode?: string;
    callHistoryMenu: ICallHistoryMenu[];
    digitalHistoryMenu?: ICallHistoryMenu[];
    callLoggingType?: string;
}

export interface CrmMetadataAction {
    name: CRM_ACTIONS | CRM_ACTION_TYPES | '';
    params?: {
        type: CRM_ACTION_TYPES | RecordType;
    };
}

export enum CRM_ACTION_TYPES {
    CREATE_USER = 'CREATE_USER',
    CALL_BACK = 'CALL_BACK',
}
export interface ICallHistoryMenu {
    action: CrmMetadataAction;
    label: string;
}
export enum PLATFORM {
    ZENDESK = 'Zendesk',
    SALESFORCE = 'Salesforce',
    HUB_SPOT = 'HubSpot',
    SERVICE_NOW = 'ServiceNow',
    DYNAMICS365 = 'Dynamics365',
    GENERIC_PLUGIN = 'GenericPlugin',
    NET_SUITE = 'NetSuite',
    ZOHO = 'Zoho',
    FRESHDESK = 'Freshdesk',
    FRESHSERVICE = 'Freshservice',
}

export interface GetCallLinkResult {
    links: CallLink[];
}

export interface GetChatLinkResult {
    links: ChatLink[];
}

export interface CallLink {
    uii: string;
    crmCallLog?: CallLog;
    crmContact?: Contact;
    agentId?: string;
    crmLoggingType?: string;
}

export interface CallLog {
    id: string;
    [P: string]: unknown;
}

export interface RecordItem {
    type?: RecordType;
    id: string;
    name?: string;
    url?: string;
}

export interface RecordResponse {
    records: RecordItem[];
}

export enum RecordType {
    USER = 'User',
    TICKET = 'Ticket',
    LEAD = 'Lead',
    CONTACT = 'Contact',
    ACCOUNT = 'Account',
    OPPORTUNITY = 'Opportunity',
    CASE = 'Case',
    DEAL = 'Deal',
    COMPANY = 'Company',
    OUTCOME = 'Outcome',
    CASE_TASK = 'CaseTask',
    CONSUMER = 'Consumer',
    CAMPAIGN = 'Campaign',
    CALL = 'Call',
    SEARCH = 'Search',
    PROSPECT = 'Prospect',
    EMPLOYEE = 'Employee',
    CUSTOMER = 'Customer',
    VENDOR = 'Vendor',
    PARTNER = 'Partner',
    TASK = 'Task',
    OTHERNAME = 'OtherName',
    SUPPORTCASE = 'SupportCase',
    TRANSACTION = 'Transaction',
    INCIDENT = 'Incident',
}
export interface SalesforceLogInfo {
    subject: string;
    relatedTo: {
        id: string;
        name: string;
    };
    name: {
        id: string;
        name: string;
    };
}

export interface ServiceNowLogInfo {
    subject: string;
    relatedTo: {
        id: string;
        name: string;
    };
    name: {
        id: string;
        name: string;
    };
}

export interface DynamicsLogInfo {
    subject: string;
    relatedTo: {
        id: string;
        name: string;
        type: RecordType;
        customerId?: string;
        accountId?: string;
        contactId?: string;
    };
    name: {
        id: string;
        name: string;
        type: RecordType;
        isSearchedResult?: boolean;
    };
    direction?: string;
}

interface ZendeskLogInfo {
    subject: string;
    ticket: {
        id: string;
    };
    user: {
        id: string;
    };
}

export interface HubSpotLogInfo {
    subject?: string;
    displayName?: string;
    outcomeId?: string;
    associations?: Array<{
        id: string;
        type: string;
    }>;
}
export interface ZohoLogInfo {
    subject: string;
    relatedTo?: {
        id: string;
        name: string;
        type: RecordType;
    };
    name?: {
        id: string;
        name: string;
        type: RecordType;
    };
}

export enum ActionEnum {
    CRM_CREATE_RECORD = 'crm_createRecord',
}

export interface Ticket {
    id: string;
    subject?: string;
    createdAt?: string;
    updatedAt?: string;
    userId: string;
    viaId?: number;
    comment?: string;
}

export class CrmError extends Error {
    code: number;
    constructor(message: string, code: number) {
        super(message);
        this.code = code;
    }
}

export enum SourceType {
    CALL_PAGE = 'callPage',
    HISTORY_PAGE = 'historyPage',
}

export interface SubmitCall
    extends CallBase,
        Pick<Partial<OnDispCall>, 'disposition' | 'notes' | 'summary'>,
        Pick<Partial<OnEndCall>, 'recordingUrl' | 'duration' | 'transcriptUrl' | 'callDts'> {
    source?: SourceType;
}

export enum ParamsType {
    CALL = 'Call',
    CHAT = 'Digital',
}
export interface OnSubmitLog {
    type: ParamsType;
    uii?: string;
    params: SubmitCall | OnChatDispResponse;
    zendeskLogInfo?: ZendeskLogInfo;
    salesforceLogInfo?: SalesforceLogInfo;
    serviceNowLogInfo?: ServiceNowLogInfo;
    dynamicsLogInfo?: DynamicsLogInfo;
    hubSpotLogInfo?: HubSpotLogInfo;
    zohoLogInfo?: ZohoLogInfo;
    netSuiteLogInfo?: NetSuiteLogInfo;
}

export interface ChatLink {
    uii: string;
    crmChatLog?: CallLog;
    crmContact?: Contact;
    agentId?: string;
}

export interface OnChatDispResponse extends ChatBase {
    disposition: string;
    notes?: string;
    summary?: string;
    transcriptUrl?: string;
}

export interface OnGetCallLink {
    calls: CallBase[];
}

export interface OnGetChatLink {
    digital: ChatBase[];
}

export enum StartRenderType {
    DIGITAL = 'Digital',
    SCRIPT = 'Script',
}

export interface OnUpdateRender {
    type: StartRenderType;
    renderId: string;
    params?: {
        scriptId?: string;
        status?: string;
    };
}

export interface OnStartRender {
    url: string;
    type: StartRenderType;
    renderId: string;
    params?: {
        scriptId?: string;
        uii?: string;
        leadPreview?: boolean;
    };
}
export interface OnStopRender extends OnUpdateRender {}

export interface RCXMetadata {
    scriptUrl: string;
}

export interface NetSuiteLogInfo {
    subject: string;
    company?: {
        id: string;
        name: string;
        type?: RecordType;
        entityId?: string;
    };
    supportCase?: {
        id: string;
        name: string;
    };
    transaction?: {
        id: string;
        name: string;
    };
    contact?: {
        id: string;
        name: string;
    };
}

export enum CallState {
    ACTIVE = 'ACTIVE',
    CALL_ENDED = 'CALL-ENDED',
}

export enum CallEventType {
    NEW_CALL = 'NEW-CALL',
    END_CALL = 'END-CALL',
}

export interface OnAcdCallbackReady {
    queueName: string;
}
